import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Alert, Button, Form, FormGroup, Modal, Table } from "react-bootstrap";
import { deleteProductType, addOrUpdateProductType, getAllProductTypesNew } from "../store/api/GetAllProduct";
import { useDispatch } from "react-redux";
import { CheckLg, DashCircle, PencilFill, PlusSquareFill, Trash } from "react-bootstrap-icons";

const ModalProductTypes = (props) => {
    const { popData, setPopData } = props;
    const { show } = popData;
    const dispatch = useDispatch();
    const [typeList, setTypeList] = useState([]);
    const [error, setError] = useState(null);
    const [currentRow, setCurrentRow] = useState(null);
    function close() {
        setPopData({ show: false });
        setError(null);
    }
    function prepareForAdd() {
        setCurrentRow({ ID: 0 });
    }
    function cancel() {
        setCurrentRow(null);
    }
    function selectRow(row) {
        delete row.e;
        setCurrentRow(row);
    }
    function onSubmit() {
        setError(null);
        if (!currentRow.Name) {
            setError("شرح نوع وارد نشده است");
            return;
        }
        const onAddEdit = (res) => {
            if (res.Data) {
                getAllProductTypesNew(setTypeList);
                setCurrentRow(null);
            }
            else if (res.Error) {
                setError(res.Error);
            }
        }
        addOrUpdateProductType(currentRow, onAddEdit);

    }
    function deletePT(row) {
        const onDelete = (res) => {
            if (res.Error) {
                setError(res.Error);
            }
            else {
                getAllProductTypesNew(setTypeList);
            }
        }
        deleteProductType(row.ID, onDelete);
    }
    useEffect(() => {
        if (show) {
            getAllProductTypesNew(setTypeList);
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>مدیریت نوع کالا</span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {error &&
                    <Alert variant="danger">
                        <span>{error}</span>
                        <FontAwesomeIcon icon={faTimes} style={{ float: "left" }} onClick={() => setError(null)} size="lg" />
                    </Alert>}
                {!currentRow ?
                    <PlusSquareFill className="hoverIcon" color="#3535b5" size={25} onClick={prepareForAdd} /> :
                    <div >
                        <FormGroup>
                            <Form.Control defaultValue={currentRow.Name} onChange={e => currentRow.Name = e.target.value} />
                        </FormGroup>
                        <Button className="group-Btn mt-1" variant="success" onClick={onSubmit}><CheckLg size={18} />&nbsp;ثبت</Button>
                        <Button className="group-Btn mt-1" variant="danger" onClick={cancel}><DashCircle size={18} />&nbsp;انصراف</Button>
                    </div>
                }
                <div style={{ overflow: "auto", maxHeight: "300px" }} className="scThin mt-1">
                    <Table className="mt-0 mb-0">
                        <thead>
                            <tr>
                                <th style={{position:"sticky", top: 0, backgroundColor: "#b6b6b6"}}>ردیف</th>
                                <th  style={{position:"sticky", top: 0, backgroundColor: "#b6b6b6"}}>نوع محصول</th>
                                <th  style={{position:"sticky", top: 0, backgroundColor: "#b6b6b6"}}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {Array.isArray(typeList ?? "") &&
                                typeList.map((row, i) =>
                                    <tr className="resultTableRow" key={i}>
                                        <td>{i + 1}</td>
                                        <td>{row.Name}</td>
                                        <td>
                                            <PencilFill color="orange" className="rowBtn" size={18} onClick={() => selectRow(row)} />&nbsp;
                                            <Trash color="red" className="rowBtn" size={18} onClick={() => deletePT(row)} />
                                        </td>
                                    </tr>)
                            }
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    )
}
export default ModalProductTypes;